import { openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-297d91bf")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("img", {
    src: _ctx.icon.url,
    title: _ctx.icon.name,
    alt: _ctx.icon.name,
    class: "img"
  }, null, 8, ["src", "title", "alt"]))
})